import { useEffect, useState } from "react";
import OficioService from "../../../../services/OficioService";
import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";

export default function PesquisaAnalistaResponsavel({ value, setValue, error }) {
    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [pesquisandoAnalista, setPesquisandoAnalista] = useState(false)

    const loading = open && pesquisandoAnalista

    const BuscaResponsavel = async () => {
        if (options.length <= 0) {
            OficioService.ConsultaAnalistasSetor()
                .then(response => {
                    response.data.forEach(data => {
                        const responsavel = {
                            ...data,
                            id: data.id,
                            nome: data.nome
                        }

                        setOptions(prevData => [
                            ...prevData,
                            responsavel
                        ])
                    })

                    setPesquisandoAnalista(false);
                })
                .catch(() => {
                    setOptions([])
                    setPesquisandoAnalista(false);
                })
        }
    }

    useEffect(() => {
        if (!loading) {
            return undefined
        }
    }, [loading])

    useEffect(() => {
        if (!open) {
            setOptions([])
        }
    }, [open])

    return (
        <Autocomplete
            multiple
            open={open}
            onOpen={() => {
                setOpen(true)
            }}
            onClose={() => {
                setOpen(false)
            }}
            value={value}
            onChange={(event, newValue) => {
                const analistasSelecionados = [];

                newValue.reduce((novoAnalista, analistaAtual) => {
                    if (novoAnalista.indexOf(analistaAtual.nome) === -1) {
                        novoAnalista.push(analistaAtual.nome);
                        analistasSelecionados.push(analistaAtual);
                    }

                    return novoAnalista;
                }, []);

                setOptions([])
                setValue(analistasSelecionados)
            }}
            //getOptionSelected={(option, value) => option.id === value.id}
            getOptionLabel={(option) => `${option.nome}`}
            options={options}
            loading={loading}
            loadingText="Carregando dados..."
            noOptionsText="Nenhum resultado encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Digite o Nome do responsável"
                    label="Analista Responsável"
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress style={{ color: 'var(--primary)' }} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    onChange={event => BuscaResponsavel(event.target.value)}
                    error={error ? error.errorState : false}
                    helperText={error ? error.errorHelperText : ""}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            )}
        />
    )
}